import { useState } from 'react';

export default function DemoSection() {
  const [activeVideo, setActiveVideo] = useState(0);

  const videos = [
    {
      title: 'Demo Completo',
      description: 'Explora todas las características de AbiSoft Explorer',
      duration: '2:30',
      thumbnail: 'https://readdy.ai/api/search-image?query=file%20manager%20software%20demo%20video%20thumbnail%20showing%20multiple%20windows%20and%20file%20operations%2C%20modern%20interface%20with%20dark%20theme%2C%20professional%20software%20demonstration%20screen&width=600&height=400&seq=demo-main&orientation=landscape'
    },
    {
      title: 'Búsqueda Instantánea',
      description: 'Encuentra archivos al instante',
      duration: '0:45',
      thumbnail: 'https://readdy.ai/api/search-image?query=search%20functionality%20demonstration%20in%20file%20manager%20showing%20search%20bar%20with%20instant%20results%2C%20file%20filtering%20and%20advanced%20search%20options%2C%20clean%20modern%20interface&width=300&height=200&seq=demo-search&orientation=landscape'
    },
    {
      title: 'Organización Inteligente',
      description: 'Carpetas que se organizan solas',
      duration: '1:15',
      thumbnail: 'https://readdy.ai/api/search-image?query=intelligent%20file%20organization%20demonstration%20showing%20automatic%20folder%20creation%2C%20file%20categorization%20and%20smart%20tagging%20system%20in%20modern%20file%20manager%20interface&width=300&height=200&seq=demo-organize&orientation=landscape'
    },
    {
      title: 'Vista Previa Avanzada',
      description: 'Previsualiza cualquier formato',
      duration: '1:00',
      thumbnail: 'https://readdy.ai/api/search-image?query=file%20preview%20functionality%20showing%20document%2C%20image%20and%20video%20preview%20panels%20in%20modern%20file%20manager%2C%20multiple%20format%20support%20demonstration&width=300&height=200&seq=demo-preview&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gray-50 dark:bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-200 rounded-full text-sm font-medium mb-4">
            EXPERIENCIA VISUAL
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            Mira AbiSoft Explorer en acción
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Descubre cómo transformamos la gestión de archivos en una experiencia fluida y poderosa
          </p>
        </div>

        {/* Video Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Main Video */}
          <div className="lg:col-span-2">
            <div className="relative group cursor-pointer">
              <img
                src={videos[activeVideo].thumbnail}
                alt={videos[activeVideo].title}
                className="w-full h-96 object-cover rounded-2xl shadow-xl"
              />
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-black/40 rounded-2xl flex items-center justify-center group-hover:bg-black/50 transition-all">
                <button className="w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-lg transform group-hover:scale-110 transition-transform">
                  <i className="ri-play-fill text-3xl text-gray-900 ml-1"></i>
                </button>
              </div>

              {/* Info Overlay */}
              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-white/90 dark:bg-gray-800/90 backdrop-blur-sm rounded-xl p-4">
                  <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                    {videos[activeVideo].title}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-300 mb-2">
                    {videos[activeVideo].description}
                  </p>
                  <div className="flex items-center text-sm text-gray-500 dark:text-gray-400">
                    <i className="ri-time-line mr-2"></i>
                    {videos[activeVideo].duration}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Video List */}
          <div className="space-y-4">
            {videos.slice(1).map((video, index) => (
              <div
                key={index + 1}
                onClick={() => setActiveVideo(index + 1)}
                className={`relative group cursor-pointer rounded-xl overflow-hidden transition-all ${
                  activeVideo === index + 1 ? 'ring-4 ring-blue-500' : 'hover:shadow-lg'
                }`}
              >
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-32 object-cover"
                />
                
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-all"></div>
                
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 bg-white/90 rounded-full flex items-center justify-center">
                    <i className="ri-play-fill text-lg text-gray-900 ml-0.5"></i>
                  </div>
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent">
                  <h4 className="text-white font-semibold text-sm mb-1">{video.title}</h4>
                  <div className="flex items-center text-xs text-gray-300">
                    <i className="ri-time-line mr-1"></i>
                    {video.duration}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Screenshots Carousel */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-gray-900 dark:text-white text-center mb-8">
            Capturas de pantalla
          </h3>
          
          <div className="flex overflow-x-auto space-x-6 pb-4">
            {[
              'https://readdy.ai/api/search-image?query=file%20manager%20list%20view%20with%20detailed%20file%20information%2C%20columns%20showing%20name%20size%20date%20modified%2C%20dark%20theme%20interface%20with%20blue%20accents%2C%20professional%20software%20screenshot&width=400&height=300&seq=screenshot-1&orientation=landscape',
              'https://readdy.ai/api/search-image?query=file%20manager%20grid%20view%20with%20large%20file%20thumbnails%2C%20image%20preview%20grid%20layout%2C%20modern%20dark%20interface%20with%20purple%20accents%2C%20organized%20file%20display&width=400&height=300&seq=screenshot-2&orientation=landscape',
              'https://readdy.ai/api/search-image?query=advanced%20search%20panel%20in%20file%20manager%20showing%20multiple%20filter%20options%2C%20search%20by%20date%20size%20type%2C%20modern%20interface%20with%20clean%20design&width=400&height=300&seq=screenshot-3&orientation=landscape',
              'https://readdy.ai/api/search-image?query=document%20preview%20panel%20in%20file%20manager%20showing%20PDF%20document%20preview%2C%20side%20panel%20layout%20with%20file%20content%20visible%2C%20professional%20interface%20design&width=400&height=300&seq=screenshot-4&orientation=landscape',
              'https://readdy.ai/api/search-image?query=file%20manager%20light%20theme%20interface%20showing%20same%20functionality%20with%20bright%20clean%20design%2C%20white%20background%20with%20blue%20accents%2C%20professional%20software&width=400&height=300&seq=screenshot-5&orientation=landscape',
              'https://readdy.ai/api/search-image?query=file%20tagging%20and%20organization%20interface%20showing%20color%20coded%20tags%2C%20smart%20folder%20system%2C%20modern%20file%20management%20with%20metadata&width=400&height=300&seq=screenshot-6&orientation=landscape'
            ].map((src, index) => (
              <div key={index} className="flex-shrink-0">
                <img
                  src={src}
                  alt={`Screenshot ${index + 1}`}
                  className="w-96 h-64 object-cover rounded-xl shadow-lg hover:shadow-xl transition-shadow cursor-pointer"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}